/* Vestiganga Mayorista — compra rápida desde las tarjetas (inicio, catálogo, recomendaciones).
   Reutiliza la lógica de paquetes de la ficha: agrega 1 unidad del paquete fijo "Docena (12)" de Shopify
   (su precio ES el que cobra el checkout) con la propiedad "Tallas" (ej. "S 3 · M 4 · L 3 · XL 2").
   Reglas: no se eligen tallas automáticamente, el botón solo se habilita cuando la suma es exactamente 12,
   se respeta el inventario (docenas disponibles − ya en el carrito, y el tope de unidades por artículo
   del carrito) y se evita el doble clic. Talla única: agrega 1 docena directa después de verificar
   precio y existencias. WhatsApp queda solo como ayuda. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var money = function (n) { return '$' + Math.round(n).toLocaleString('es-CO'); };
  var esc = function (t) { var d = document.createElement('div'); d.textContent = t == null ? '' : t; return d.innerHTML; };
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var pl = function (n) { return n + (n === 1 ? ' prenda' : ' prendas'); };

  function prendasOf(c) {
    if (window.vgPrendas) return window.vgPrendas(c);
    var t = 0; (c.items || []).forEach(function (it) {
      var u = 0; (it.options_with_values || []).forEach(function (o) { if (/^paquetes?$/i.test(String(o.name).trim())) { var m = String(o.value).match(/\((\d+)\)/); if (m) u = Number(m[1]); } });
      t += it.quantity * (u || 1);
    }); return t;
  }
  function getCart() { return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function addToCart(item) {
    return fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [item] }) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); });
  }
  function inCartOf(c, id) { var q = 0; (c.items || []).forEach(function (it) { if (it.variant_id === id) q += it.quantity; }); return q; }
  /* Docenas que todavía se pueden agregar de este paquete */
  function canAdd(P, c) {
    var cap = P.maxUnits > 0 ? Math.floor(P.maxUnits / P.units) : Infinity;
    return Math.max(0, Math.min(P.inv || 0, cap) - inCartOf(c, P.id));
  }
  function setCount(c) { $$('[data-vg-cart-count]').forEach(function (e) { e.textContent = prendasOf(c); }); }

  /* ---------- Panel ---------- */
  var M, st = null, lastFocus = null;
  function build() {
    if (M) return M;
    M = document.createElement('div');
    M.className = 'vg vg-qb'; M.hidden = true;
    M.setAttribute('data-vg-qb-modal', '');
    M.innerHTML =
      '<div class="vg-qb__bg" data-qb-close></div>' +
      '<div class="vg-qb__panel" role="dialog" aria-modal="true" aria-labelledby="vg-qb-t">' +
        '<button type="button" class="vg-qb__x" data-qb-close aria-label="Cerrar">×</button>' +
        '<div class="vg-qb__head"><div class="vg-qb__img" data-qb-img></div><div>' +
          '<div class="vg-qb__ref" data-qb-ref></div><h2 class="vg-qb__t" id="vg-qb-t" data-qb-name></h2>' +
          '<div class="vg-qb__price num"><b data-qb-total></b> <span>la docena (12 prendas)</span></div>' +
          '<div class="vg-qb__unit num" data-qb-unit></div>' +
        '</div></div>' +
        '<div class="vg-surt vg-surt--sm vg-qb__surt"><span class="vg-surt__dots" aria-hidden="true"><i style="--c:#F6C6D4"></i><i style="--c:#BFE6D3"></i><i style="--c:#D8CCF1"></i><i style="--c:#FAD9C1"></i><i style="--c:#C7E1F4"></i><i style="--c:#F6EAB4"></i></span><span class="vg-surt__t">Colores y diseños surtidos</span></div>' +
        '<div data-qb-pick>' +
          '<div class="vg-qb__lab">Reparte las 12 prendas por talla</div>' +
          '<div class="vg-qb__sizes" data-qb-sizes></div>' +
          '<div class="vg-qb__meter" aria-hidden="true"><i data-qb-meter></i></div>' +
          '<p class="vg-qb__count" data-qb-count aria-live="polite"></p>' +
          '<div class="vg-qb__msg" data-qb-msg hidden></div>' +
          '<button type="button" class="vg-btn vg-btn--primary vg-btn--block" data-qb-add disabled>Añadir docena al carrito</button>' +
        '</div>' +
        '<div data-qb-done hidden>' +
          '<div class="vg-qb__ok" role="status" data-qb-ok></div>' +
          '<div class="vg-qb__acts"><button type="button" class="vg-btn vg-btn--ghost vg-btn--block" data-qb-close>Seguir comprando</button>' +
          '<a class="vg-btn vg-btn--primary vg-btn--block" data-qb-cart href="' + ROOT + 'cart">Ver carrito</a></div>' +
        '</div>' +
        '<a class="vg-qb__help" target="_blank" rel="noopener" data-qb-help href="#">¿Necesitas ayuda? Escríbenos por WhatsApp</a>' +
      '</div>';
    document.body.appendChild(M);
    M.addEventListener('click', function (e) {
      if (e.target.closest('[data-qb-close]')) { close(); return; }
      var b = e.target.closest('[data-qb-z]'); if (b && st && !st.busy) { setSize(b.dataset.qbZ, (st.dist[b.dataset.qbZ] || 0) + Number(b.dataset.d)); draw(); return; }
      if (e.target.closest('[data-qb-add]')) submit();
    });
    M.addEventListener('change', function (e) { var i = e.target.closest('[data-qb-in]'); if (i && st && !st.busy) { setSize(i.dataset.qbIn, i.value); draw(); } });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && M && !M.hidden) close(); });
    return M;
  }
  function open(P, card, mode) {
    build();
    lastFocus = document.activeElement;
    st = { P: P, card: card, dist: {}, busy: false, left: null, err: null };
    $('.vg-qb__lab', M).hidden = false; $('.vg-qb__meter', M).hidden = false;
    P.sizes.forEach(function (z) { st.dist[z] = 0; });
    $('[data-qb-img]', M).innerHTML = P.img ? '<img src="' + esc(P.img) + '" alt="" width="80" height="100">' : '';
    $('[data-qb-ref]', M).textContent = P.ident !== P.name ? P.ident : '';
    $('[data-qb-name]', M).textContent = P.name;
    $('[data-qb-total]', M).textContent = money(P.price);
    $('[data-qb-unit]', M).textContent = (P.price % P.units ? '≈ ' : '') + money(P.price / P.units) + ' por prenda · venta únicamente por docena';
    var help = card ? $('.vg-pc__help', card) : null;
    var hb = $('[data-qb-help]', M); if (help) { hb.href = help.href; hb.hidden = false; } else hb.hidden = true;
    $('[data-qb-pick]', M).hidden = mode === 'done';
    $('[data-qb-done]', M).hidden = mode !== 'done';
    M.hidden = false; document.documentElement.classList.add('vg-qb-open');
    if (mode !== 'done') {
      $('[data-qb-add]', M).disabled = true;
      draw();
      getCart().then(function (c) { st.left = canAdd(P, c); draw(); }).catch(function () { st.left = 0; draw(); });
      setTimeout(function () { var f = $('[data-qb-z][data-d="1"]', M); if (f) f.focus(); }, 30);
    } else {
      setTimeout(function () { var f = $('[data-qb-cart]', M); if (f) f.focus(); }, 30);
    }
  }
  function close() {
    if (!M || M.hidden || (st && st.busy)) return;
    M.hidden = true; document.documentElement.classList.remove('vg-qb-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function total() { var t = 0; Object.keys(st.dist).forEach(function (k) { t += st.dist[k] || 0; }); return t; }
  function setSize(z, v) { v = Math.max(0, Math.floor(Number(v) || 0)); st.dist[z] = v; }
  function distText() { return st.P.sizes.filter(function (z) { return st.dist[z] > 0; }).map(function (z) { return z + ' ' + st.dist[z]; }).join(' · '); }
  function draw() {
    if (!st) return;
    var P = st.P, tg = P.units, tot = total();
    $('[data-qb-sizes]', M).innerHTML = P.sizes.map(function (z) {
      var v = st.dist[z] || 0;
      return '<div class="vg-qb__c"><b>' + esc(z) + '</b><div class="vg-qb__stp">' +
        '<button type="button" data-qb-z="' + esc(z) + '" data-d="-1" aria-label="Menos talla ' + esc(z) + '"' + (v <= 0 || st.busy ? ' disabled' : '') + '>–</button>' +
        '<input type="number" inputmode="numeric" min="0" max="12" value="' + v + '" data-qb-in="' + esc(z) + '" aria-label="Prendas talla ' + esc(z) + '"' + (st.busy ? ' disabled' : '') + '>' +
        '<button type="button" data-qb-z="' + esc(z) + '" data-d="1" aria-label="Más talla ' + esc(z) + '"' + (tot >= tg || st.busy ? ' disabled' : '') + '>+</button></div></div>';
    }).join('');
    var m = $('[data-qb-meter]', M); m.style.width = Math.min(100, tot / tg * 100) + '%';
    m.parentNode.classList.toggle('is-ok', tot === tg); m.parentNode.classList.toggle('is-over', tot > tg);
    var c = $('[data-qb-count]', M);
    c.className = 'vg-qb__count' + (tot === tg ? ' is-ok' : tot > tg ? ' is-over' : '');
    c.innerHTML = '<b>Has seleccionado ' + tot + ' de 12 prendas</b><br>' + (tot > tg ? 'Te pasaste por ' + pl(tot - tg) + '. Ajusta las tallas.' : tot === tg ? 'Docena completa: ' + esc(distText()) + '.' : 'Te faltan ' + pl(tg - tot) + '.');
    var msg = $('[data-qb-msg]', M), add = $('[data-qb-add]', M);
    var noStock = !P.available || (st.left !== null && st.left < 1);
    if (noStock) {
      msg.hidden = false; msg.className = 'vg-qb__msg is-warn';
      msg.textContent = !P.available ? 'Esta referencia está agotada.' : 'Ya tienes en tu carrito el máximo de docenas disponibles de esta referencia por pedido.';
    } else if (!st.err) msg.hidden = true;
    add.disabled = st.busy || noStock || st.left === null || tot !== tg;
    add.textContent = st.busy ? 'Añadiendo…' : 'Añadir docena al carrito · ' + money(P.price);
  }
  function showDone(P, c, dt) {
    $('[data-qb-pick]', M).hidden = true; $('[data-qb-done]', M).hidden = false;
    $('[data-qb-ok]', M).innerHTML = '<b>Listo, agregaste 1 docena al carrito.</b><br>' + esc(P.ident) + (dt ? ' · ' + esc(dt) : ' · Talla única') + ' · ' + money(P.price) +
      (c ? '<br><span>Tu carrito suma ' + pl(prendasOf(c)) + ' · ' + money(c.total_price / 100) + '.</span>' : '');
    setCount(c);
    setTimeout(function () { var f = $('[data-qb-cart]', M); if (f) f.focus(); }, 30);
  }
  function submit() {
    var P = st.P; if (st.busy) return;
    if (total() !== P.units || !(st.left >= 1) || !P.available) { draw(); return; }
    st.busy = true; st.err = null; draw();
    var dt = distText();
    addToCart({ id: P.id, quantity: 1, properties: { 'Tallas': dt } }).then(function (res) {
      if (!res.ok) throw new Error(res.j.description || res.j.message || 'No se pudo añadir la docena.');
      return getCart();
    }).then(function (c) { st.busy = false; showDone(P, c, dt); })
      .catch(function (err) {
        st.busy = false; st.err = err.message;
        return getCart().then(function (c) { st.left = canAdd(P, c); }).catch(function () {}).then(function () {
          draw(); var msg = $('[data-qb-msg]', M); msg.hidden = false; msg.className = 'vg-qb__msg is-err'; msg.textContent = st.err;
        });
      });
  }

  /* ---------- Botón de la tarjeta ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-vg-qb]'); if (!btn) return;
    e.preventDefault();
    if (btn.dataset.busy) return;                       /* evita doble clic */
    var card = btn.closest('.vg-pc') || btn.parentNode;
    var el = $('[data-vg-qb-json]', card); if (!el) return;
    var P; try { P = JSON.parse(el.textContent); } catch (x) { return; }
    P.sizes = (P.sizes || []).map(function (z) { return String(z).trim(); }).filter(Boolean);
    if (!(P.price > 0) || !P.id) return;                /* sin precio verificado no se vende */
    if (P.sizes.length) { open(P, card, 'pick'); return; }
    /* Talla única: 1 docena directa, verificando existencias en el momento */
    btn.dataset.busy = '1'; var label = btn.textContent; btn.disabled = true; btn.textContent = 'Añadiendo…';
    var reset = function () { delete btn.dataset.busy; btn.disabled = false; btn.textContent = label; };
    getCart().then(function (c) {
      if (!P.available || canAdd(P, c) < 1) throw new Error(!P.available ? 'Esta referencia está agotada.' : 'Ya tienes en tu carrito el máximo de docenas disponibles de esta referencia por pedido.');
      return addToCart({ id: P.id, quantity: 1 });
    }).then(function (res) {
      if (!res.ok) throw new Error(res.j.description || res.j.message || 'No se pudo añadir la docena.');
      return getCart();
    }).then(function (c) { reset(); open(P, card, 'done'); showDone(P, c, ''); })
      .catch(function (err) {
        reset(); open(P, card, 'pick');
        st.left = 0; st.err = err.message; draw();
        var msg = $('[data-qb-msg]', M); msg.hidden = false; msg.className = 'vg-qb__msg is-err'; msg.textContent = err.message;
        $('[data-qb-sizes]', M).innerHTML = ''; $('[data-qb-count]', M).innerHTML = ''; $('.vg-qb__lab', M).hidden = true; $('.vg-qb__meter', M).hidden = true;
      });
  });
})();
